module.exports = __webpack_public_path__ + "static/media/ic-exclamation.e6b4a567.svg";